const linkElement = document.querySelector('.threw-d-view-link');

if (linkElement) {
    linkElement.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Get the target element
        const target = document.querySelector('#three-d-view');

        if (target) {
            // Scroll to the target element and adjust for the sticky header
            const headerHeight = 165; // Height of the sticky header in pixels
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth' // Smooth scrolling
            });
        } else {
            console.warn('Target element #three-d-view not found.');
        }
    });
} else {
    console.warn('.threw-d-view-link element not found.');
}

// Dimensions (i) tooltip: tap/click toggles, tap elsewhere or Esc closes
document.querySelectorAll('.dims-tip').forEach(function (tip) {
    const button = tip.querySelector('.dims-tip__btn');
    const bubble = tip.querySelector('.dims-tip__bubble');

    const desktop = window.matchMedia('(min-width: 990px)');

    // Text the bubble must not cover on desktop: the price / List Price / $ OFF line and the
    // Shop Pay Installments line (its text lives in a shadow root)
    function textRects(root, out) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        while (walker.nextNode()) {
            if (!walker.currentNode.textContent.trim()) continue;
            range.selectNodeContents(walker.currentNode);
            Array.prototype.forEach.call(range.getClientRects(), function (r) {
                if (r.width) out.push(r);
            });
        }
        return out;
    }

    function obstacles() {
        const rects = [];
        const price = document.querySelector('.product__info-container #custom-pricing');
        if (price) {
            textRects(price, rects);
            Array.prototype.forEach.call(price.querySelectorAll('.price-saving'), function (pill) {
                rects.push(pill.getBoundingClientRect());
            });
        }
        const terms = document.querySelector('.product__info-container form.installment shopify-payment-terms');
        if (terms && terms.shadowRoot) {
            textRects(terms.shadowRoot, rects);
            Array.prototype.forEach.call(terms.shadowRoot.querySelectorAll('svg, img'), function (logo) {
                rects.push(logo.getBoundingClientRect());
            });
        }
        return rects;
    }

    // Right edge of the obstacles that share rows with the bubble (0 if none do)
    function blockedRight(rect, shift) {
        return obstacles().reduce(function (max, r) {
            const sharesRows = r.bottom > rect.top && r.top < rect.bottom;
            const sharesColumns = r.right > rect.left + shift && r.left < rect.right + shift;
            return sharesRows && sharesColumns ? Math.max(max, r.right) : max;
        }, 0);
    }

    // Keep the bubble on screen; on desktop also keep it clear of the price. The arrow stays under the (i)
    function position() {
        bubble.style.transform = '';
        bubble.style.width = '';
        bubble.style.removeProperty('--dims-tip-shift');
        tip.classList.remove('is-above');

        let rect = bubble.getBoundingClientRect();
        const viewportRight = document.documentElement.clientWidth - 16;
        let shift = 0;
        if (rect.left < 16) shift = 16 - rect.left;
        else if (rect.right > viewportRight) shift = viewportRight - rect.right;

        const blocked = desktop.matches ? blockedRight(rect, shift) : 0;
        if (blocked) {
            const avoidLeft = blocked + 12;
            let fits = false;
            if (viewportRight - avoidLeft >= 200) {
                // Narrow the bubble to fit between the price text and the screen edge
                bubble.style.width = (viewportRight - avoidLeft) + 'px';
                rect = bubble.getBoundingClientRect();
                shift = avoidLeft - rect.left;
                if (rect.right + shift > viewportRight) shift = viewportRight - rect.right;
                fits = !blockedRight(rect, shift);
            }
            if (!fits) {
                // No room beside the price: open above the specs instead
                bubble.style.width = '';
                shift = 0;
                tip.classList.add('is-above');
                rect = bubble.getBoundingClientRect();
                if (rect.right > viewportRight) shift = viewportRight - rect.right;
            }
        }

        if (shift) {
            bubble.style.transform = 'translateX(' + shift + 'px)';
            bubble.style.setProperty('--dims-tip-shift', shift + 'px');
        }
    }

    let openedByHover = false;
    let closeTimer = null;

    function setOpen(open) {
        clearTimeout(closeTimer);
        if (!open) openedByHover = false;
        tip.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Measure only once the bubble is showing
        if (open) position();
    }

    // Desktop hover: open on enter, close shortly after leaving so the mouse can travel to the link
    const canHover = window.matchMedia('(hover: hover)');
    tip.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        if (!tip.classList.contains('is-open')) {
            setOpen(true);
            openedByHover = true;
        }
    });
    tip.addEventListener('mouseleave', function () {
        if (!openedByHover) return;
        closeTimer = setTimeout(function () {
            setOpen(false);
        }, 200);
    });

    // Keyboard: open when the (i) is tabbed to, close when focus leaves the tooltip
    button.addEventListener('focus', function () {
        if (button.matches(':focus-visible') && !tip.classList.contains('is-open')) setOpen(true);
    });
    tip.addEventListener('focusout', function (event) {
        if (!tip.contains(event.relatedTarget) && !openedByHover) setOpen(false);
    });

    button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        // A click on a hover-opened bubble pins it open instead of closing it
        if (openedByHover) {
            openedByHover = false;
            clearTimeout(closeTimer);
            return;
        }
        setOpen(!tip.classList.contains('is-open'));
    });

    document.addEventListener('click', function (event) {
        if (!tip.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && (tip.classList.contains('is-open') || tip.contains(document.activeElement))) {
            setOpen(false);
            button.focus();
        }
    });

    // A #specifications link in the tooltip text (theme editor setting): open the Specifications accordion and scroll to it
    const link = tip.querySelector('.dims-tip__bubble a[href="#specifications"]');
    if (!link) return;

    // The accordion is built by snippets/product-description.liquid from the description's h6 headings
    function findSpecsTrigger() {
        return Array.prototype.find.call(document.querySelectorAll('.js-unique-trigger'), function (trigger) {
            const heading = trigger.querySelector('.product-single__accordion__title-text');
            return heading && heading.textContent.trim().toLowerCase() === 'specifications';
        });
    }

    // No Specifications on this product: leave the words as plain text
    window.addEventListener('load', function () {
        if (!findSpecsTrigger()) link.replaceWith(document.createTextNode(link.textContent));
    });

    link.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        if (document.activeElement) document.activeElement.blur();

        const trigger = findSpecsTrigger();
        if (!trigger) return;

        const panel = document.querySelector(trigger.getAttribute('href'));
        if (panel && !panel.classList.contains('js-active')) trigger.click();

        // Clear the sticky header, same idea as the 3D view link above
        const header = document.querySelector('sticky-header, .header-wrapper');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const targetPosition = trigger.getBoundingClientRect().top + window.pageYOffset - headerHeight - 12;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    });
});
